module.exports = __webpack_public_path__ + "img/icon.1e4cfad9.png";